import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-182a4cfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "processJobsBoard" }
const _hoisted_2 = { class: "white-background" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mt-2" }, " All Tasks ", -1))
const _hoisted_4 = { class: "display-type" }
const _hoisted_5 = { class: "item active" }
const _hoisted_6 = { class: "page h-100" }
const _hoisted_7 = { class: "row h-100" }
const _hoisted_8 = { class: "col-md-4 h-100" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "In-Active", -1))
const _hoisted_10 = { class: "scroll-wrapper pe-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Coming soon", -1))
const _hoisted_12 = { class: "col-md-4 h-100" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Active", -1))
const _hoisted_14 = { class: "scroll-wrapper pe-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Coming soon", -1))
const _hoisted_16 = { class: "col-md-4 h-100" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Done", -1))
const _hoisted_18 = { class: "scroll-wrapper pe-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Coming soon", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_job_element_wrapper = _resolveComponent("job-element-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_feather_icon, {
            type: "columns",
            class: "cursor-pointer",
            size: "16"
          }),
          _createTextVNode(" Board view ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_job_element_wrapper, {
              model: _ctx.inActiveJobs,
              "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inActiveJobs) = $event)),
              title: "Inactive Jobs",
              type: "inActiveJobs",
              onSetSelectedJob: _ctx.setSelectedJob,
              onSetSelectedTask: _ctx.setSelectedTask
            }, null, 8, ["model", "onSetSelectedJob", "onSetSelectedTask"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_job_element_wrapper, {
              model: _ctx.activeJobs,
              "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeJobs) = $event)),
              title: "Active Jobs",
              type: "activeJobs",
              onSetSelectedJob: _ctx.setSelectedJob,
              onSetSelectedTask: _ctx.setSelectedTask
            }, null, 8, ["model", "onSetSelectedJob", "onSetSelectedTask"])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_job_element_wrapper, {
              model: _ctx.doneJobs,
              "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.doneJobs) = $event)),
              title: "Completed Jobs",
              type: "doneJobs",
              onSetSelectedJob: _ctx.setSelectedJob,
              onSetSelectedTask: _ctx.setSelectedTask
            }, null, 8, ["model", "onSetSelectedJob", "onSetSelectedTask"])
          ])
        ])
      ])
    ])
  ]))
}